import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import AreaAtuacaoService from "../../services/AreaAtuacaoService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormAreaAtuacao extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idAreaAtuacao: "",
            nome: ""
        };

        this.state.crud = {
            service: AreaAtuacaoService,
            labels: {
                title: 'Área de Atuação',
            },
            urlList: '/LstAreaAtuacao',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idAreaAtuacao} name="idAreaAtuacao" readOnly opcionalLabel={false}/>
                <InputText label="Nome do Área de Atuação" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormAreaAtuacao {...props} navigate={navigate} params={params} />
}

export default With